import { CSSProperties } from "react";

import { Button } from "semantic-ui-react";

type ModEvaluationResultProps = {
  result: string;
  onClose: () => void;
};

type Styles = Record<
  "checkIcon" | "container" | "contentBox" | "header" | "okButton" | "resultRow" | "resultText",
  CSSProperties
>;

const styles: Styles = {
  checkIcon: {
    color: "#4CAF50",
    flexShrink: 0,
    fontSize: "24px",
  },
  container: {
    backgroundColor: "var(--primary-theme-color)",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    left: "50%",
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "92.5%",
    zIndex: 1000,
  },
  contentBox: {
    backgroundColor: "white",
    border: "3px dashed #ccc",
    borderRadius: "8px",
    fontSize: "13px",
    margin: "10px",
    padding: "10px",
  },
  okButton: {
    backgroundColor: "white",
    border: "none",
    borderRadius: "8px",
    color: "var(--primary-theme-color)",
  },
  resultRow: {
    alignItems: "flex-start",
    display: "flex",
    gap: "5px",
  },
  resultText: {
    color: "#333",
    fontSize: "13px",
    lineHeight: "1.6",
  },
  header: {
    alignItems: "center",
    color: "#3c3c3c",
    display: "flex",
    fontWeight: "bold",
    padding: "20px 12px 0px",
  },
};

const ModEvaluationResult = (props: ModEvaluationResultProps) => (
  <div style={styles.container}>
    <div style={styles.header}>
      <label style={{ marginRight: "0.5rem" }}>Evaluation Result/ Suggestion:</label>
      <img style={{ width: "14px" }} src="/images/common/icon_evaluation_result.png" />
    </div>

    <div style={styles.contentBox}>
      <div style={styles.resultRow}>
        <div style={styles.checkIcon}>✓</div>
        <div style={styles.resultText}>{props.result}</div>
      </div>
    </div>

    <div
      style={{
        padding: "5px 15px 15px",
        textAlign: "center",
      }}
    >
      <Button style={styles.okButton} onClick={props.onClose}>
        OK
      </Button>
    </div>
  </div>
);

export default ModEvaluationResult;
